<div class="h-full flex flex-col w-full min-w-0 overflow-hidden">
    <!-- Back Button -->
    <div class="m-2 flex flex-row items-center cursor-pointer" (click)="goBack()">
        <i class="pi pi-chevron-left text-sm"></i>
        <span class="font-bold text-sm ml-2">Review Q&A</span>
    </div>

    <!-- Tabs - Responsive -->
    <div class="w-full overflow-x-auto">
        <p-tabs [value]="getActiveTabValue()" class="custom-tabview w-full">
            <p-tablist>
                <p-tab *ngFor="let item of tabs; let index = index" [value]="index.toString()" pRipple
                    [routerLink]="item.routerLink" class="flex items-center !gap-2">
                    <a pRipple class="p-menuitem-link flex items-center gap-2"
                        [ngClass]="{'active-tab': isActive(item.routerLink)}">
                        @if(item.img){
                        <img [src]="item.img" alt="icon" class="w-5 h-5 tab-icon svg-icon-base"
                            [ngClass]="{'svg-icon': !isActive(item.routerLink), 'active-svg-icon': isActive(item.routerLink)}">
                        }@else{
                        <span [class]="item.icon"></span>
                        }
                        <span class="ml-2 text-gray-500 font-sans text-sm whitespace-nowrap"
                            [ngClass]="{'text-gray-500': !isActive(item.routerLink)}">{{
                            item.label }}</span>
                    </a>
                </p-tab>
            </p-tablist>
        </p-tabs>
    </div>

    <!-- Router Outlet with Proper Overflow -->
    <div class="flex-1 min-h-0 overflow-hidden w-full">
        <router-outlet></router-outlet>
    </div>
</div>